export const API_PATH_ApiAlertMgtmRegionsLocationsGet = '/services/alerts-mgtm/apiAlertMgtmRegionsLocationsGet';
